import {get, post} from './walletAxios';
import {Lobby, LobbyCreate} from "../app/types/lobby";

export const LOBBY_PATH = '/api/lobby';

export const getLobbies = async (): Promise<Lobby[]> => {
    return get(`${LOBBY_PATH}`).then(response => response ?? []);
};

export const getLobby = async (id: number, includeUsers: boolean = true): Promise<Lobby> => {
    return get(`${LOBBY_PATH}/${id}?includeUsers=${includeUsers}`).then(response => response ?? {});
};

export const createLobby = async (lobby: LobbyCreate) => {
    return post(`${LOBBY_PATH}`, lobby).then(response => response ?? []);
};

export const connectToLobby = async (id: number, password: string) => {
    return post(`${LOBBY_PATH}/${id}/join?password=${password}`).then(response => response ?? []);
};
